import { MicrophoneSlashIcon } from '@quickmd-llc/design-system'
import { useRemoteMediaTrackState } from '../hooks/useRemoteMediaTrackState'

/**
 * Redesign-native replacement for the legacy RemoteParticipantStatusInfo mic indicator.
 * Shows a mic-slash badge over the patient's video whenever the patient is muted. Because
 * ForegroundLayer overlays BackgroundLayer, this stays visible while the patient's camera is
 * off (i.e. over the RemoteVideoOffContent avatar) as well as over their live video.
 */
export function RemotePatientMuteBadge() {
  const { isAudioTrackOn } = useRemoteMediaTrackState()

  if (isAudioTrackOn) return null

  return (
    <div data-testid='patient-mute-badge' className='flex items-center rounded-full bg-popup-overlay px-sp-1 py-sp-0.5'>
      <MicrophoneSlashIcon iconSize='m' className='text-white' />
    </div>
  )
}
